import profilePic from "./image/author-profile.jpg";

export const personalInfo = {
  name: "Avishek Gupta",
  title: "Analytics Engineer",
  tagline: "Data Warehousing | Analytics Engineering | AWS Certified",
  email: "avishek1379@gmail.com",
  mobile: "+91 98045-80669",
  linkedin: "https://www.linkedin.com/in/avishekgupta96",
  github: "https://github.com/avishek1379-creator",
  location: "Kolkata, India",
  profileImage: profilePic
};

export const cvData = {
  title: "Know More",
  description: "View or download my detailed CV to learn more about my professional journey.",
  filePath: "/cv/AG_CV.pdf",
  label: "View My CV"
};

export const aboutData = {
  summary: "Analytics Engineer with 7+ years of experience in data transformation and data warehousing using Informatica, AWS, and Python. Experienced in building optimized ETL pipelines and reconciliation frameworks, with a strong focus on performance, reliability, and scalability. Driven by problem-solving and continuous learning.",
  highlights: [
    "Delivered a reconciliation framework achieving results within a tolerance threshold of 5%",
    "Reduced HIVE-based data processing time by 84% through query optimization",
    "Improved reinsurance file processing by reducing manual effort by 50%",
	"Automated S2T document preparation using PowerCenter workflow, XML and shell scripting",
    "Collaborated with DevOps and cross-functional stakeholders to finalize end-to-end design specifications required for one of the projects"
  ]
};

export const experienceData = [
  {
    id: 1,
    company: "Tata Consultancy Services",
    role: "Information Technology Analyst",
    period: "Mar 2022 - Present",
    location: "Kolkata",
    responsibilities: [
      "Progressed from a junior developer to a senior contributor, handling diverse responsibilities across analytics and data engineering initiatives",
      "Built and maintained Informatica BDM pipelines with complex transformation logic, delivering solutions end-to-end",
      "Optimized HIVE-based reconciliation workflows, integrating Spark execution on EMR to generate structured Excel reports",
      "Contributed to solution design, capacity planning, and workflow orchestration for one of the data lake projects"
    ]
  },
  {
    id: 2,
    company: "Cognizant",
    role: "Associate",
    period: "Jun 2018 - Feb 2022",
    location: "Kolkata",
    responsibilities: [
      "Progressed from trainee to a reliable junior developer, handling tasks independently across multiple ETL workflows",
      "Gathered business requirements and developed Informatica PowerCenter mappings, automating job execution using Tivoli Scheduler",
      "Designed and implemented automation to streamline S2T document preparation, significantly reducing manual effort",
      "Contributed to the EDMS program, loading legacy mainframe data (VSAM, DB2) into HDFS using PowerCenter",
	  "Owned and supported VRPS and GPAY applications, ensuring reliable data ingestion and processing"
    ]
  }
];

export const skillsData = {
  languages: [
    "Python",
    "SQL",
    "Bash/Shell"
  ],
  tools: [
    "Informatica PowerCenter",
    "Informatica BDM",
    "Git",
    "Tivoli Scheduler",
	"Jenkins",
	"DBT"
  ],
  databases: [
    "Oracle",
	"PostgreSQL",
    "MSSQL",
    "Snowflake"
  ],
  frameworks: [
    "Pandas",
    "Openpyxl"
  ],
  cloud: [
    "AWS (S3, EC2, EMR)"
  ]
};


